module.exports = function (searchService, $state) {
    return {
        scope: {
            multisearchItem: '=',
            disableLinks: '='
        },
        restrict: 'EA',
        link(scope) {
            scope.search = searchService;

            scope.showDisabledLink = function (type) {
                if (scope.search.SearchCount.loadingCount) {
                    return false;
                }

                switch (type) {
                    case 'products':
                        return scope.search.SearchCount.ProductCount <= 0 || scope.disableLinks;
                    case 'specials':
                        return scope.search.SearchCount.SpecialProductCount <= 0 || scope.disableLinks;
                    case 'recipes':
                        return scope.search.SearchCount.RecipeCount <= 0 || scope.disableLinks;
                    case 'articles':
                        return scope.search.SearchCount.ArticleCount <= 0 || scope.disableLinks;

                    default:
                        return false;
                }
            };

            scope.isState = function (state, exact) {
                if (exact) {
                    return $state.is(state);
                }
                return $state.includes(state);
            };
        },
        template: require('./search-navigation-results-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-navigation-results-directive.js
 **/